import { KIPIFY_FILTER_APPLY_BUTTON_CLASS } from '../kipifyUi';

export const MuiButton = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      fontFamily: 'Sarabun',
      borderRadius: '6px',
      fontWeight: '700',
      lineHeight: '21px',
      fontSize: '16px',
      boxShadow: 'none',
      padding: '15.5px 20px',

      /** Apply nelle barre filtri (Period/Compare): niente padding verticale vs TextField `size="small"`. */
      [`&.MuiButton-contained.MuiButton-sizeSmall.${KIPIFY_FILTER_APPLY_BUTTON_CLASS}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: '8px',
        paddingRight: '8px',
        boxSizing: 'border-box',
        fontSize: '0.875rem',
        fontWeight: 600,
        lineHeight: 1.2,
      },

      '&.MuiButton-textPrimary': {
        textTransform: 'none',
      },
    },
    contained: {
      background: '#1EED9F',
      color: '#222822',

      '&:hover': {
        backgroundColor: '#1ED993',
        boxShadow: 'none',
      },

      '&:active': {
        background: '#0FB678',
        boxShadow: 'none',
      },

      '&.Mui-disabled': {
        background: '#DDDDEA',
        color: '#9F9F9F',
      },

      '&.MuiButton-containedSecondary': {
        background: 'rgba(59, 64, 59, 1)',
        color: 'rgba(30, 237, 159, 1)',

        '&:hover': {
          opacity: '0.9',
          boxShadow: 'none',
        },

        '&:active': {
          opacity: '0.8',
          boxShadow: 'none',
        },

        '&.Mui-disabled': {
          background: '#DDDDEA',
          color: '#9F9F9F',
        },
      },
    },
    outlined: {
      borderColor: 'rgba(30, 237, 159, 1)',
      color: 'rgba(34, 40, 34, 1)',
      padding: '14.5px 20px',

      '&:hover': {
        backgroundColor: 'rgba(30, 237, 159, 0.1)',
        borderColor: 'rgba(30, 237, 159, 1)',
        boxShadow: 'none',
      },

      '&:active': {
        background: 'rgba(30, 237, 159, 0.2)',
        borderColor: 'rgba(30, 237, 159, 1)',
        boxShadow: 'none',
      },

      '&.Mui-disabled': {
        background: '#DDDDEA',
        color: '#9F9F9F',
      },
    },
    text: {
      padding: 0,
      color: 'rgba(159, 159, 159, 1)',
      width: 'fit-content',

      '&:hover': {
        background: 'none',
        border: 'none',
        boxShadow: 'none',
        color: 'rgba(1, 128, 148, 1)',
      },

      '.MuiButton-endIcon': {
        marginLeft: '5px',
        marginRight: 0,

        svg: {
          width: '24px',
          height: '24px',
        },
      },
    },
  },
};
